"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AlarmTriggered = function AlarmTriggered(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M22.5,0h-21C0.7,0,0,0.7,0,1.6v20.9C0,23.3,0.7,24,1.5,24h21c0.8,0,1.5-0.7,1.5-1.6V1.6C24,0.7,23.3,0,22.5,0z M20.5,18.8h-8.1c-0.2,1.2-1.2,2.1-2.4,2.1S7.8,20,7.6,18.8h-4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4c0.2-1.2,1.2-2.1,2.4-2.1 s2.2,0.9,2.4,2.1h8.1c0.3,0,0.5,0.2,0.5,0.5S20.8,18.8,20.5,18.8z M20.5,12.5H10.4c-0.2,1.2-1.2,2.1-2.4,2.1s-2.2-0.9-2.4-2.1h-2 C3.2,12.5,3,12.3,3,12s0.2-0.5,0.5-0.5h2C5.8,10.3,6.8,9.4,8,9.4s2.2,0.9,2.4,2.1h10.1c0.3,0,0.5,0.2,0.5,0.5S20.8,12.5,20.5,12.5z M20.5,6.3h-6.1c-0.2,1.2-1.2,2.1-2.4,2.1S9.8,7.5,9.6,6.3h-6C3.2,6.3,3,6,3,5.7s0.2-0.5,0.5-0.5h6C9.8,4,10.8,3.1,12,3.1 s2.2,0.9,2.4,2.1h6.1c0.3,0,0.5,0.2,0.5,0.5S20.8,6.3,20.5,6.3z"
  }));
};

var _default = AlarmTriggered;
exports["default"] = _default;